import {useEffect} from "react";
import {MechanicalPreferencesJson} from "../business/ApiJsonTypes";
import {readPreferredSelectionCriteria, withMechanicalConfigurationApplied, writePreferredSelectionCriteria} from "../pages/selection/preferredSelectionCriteriaStorage";

/**
 * Whenever the mechanical configurator changes shaft/mechanical preferences, feed them back into
 * the remembered selection criteria so returning to the start of the selection flow shows the
 * latest shaft settings. Only augments existing remembered criteria - it never fabricates new ones.
 */
export function useSyncShaftPreferencesToSelectionSession(mechanicalPreferences: MechanicalPreferencesJson,
                                                          realizeWithClutch: boolean): void {
    useEffect(() => {
        const remembered = readPreferredSelectionCriteria();
        if (remembered === null) {
            return;
        }
        writePreferredSelectionCriteria(
            withMechanicalConfigurationApplied(remembered, mechanicalPreferences, realizeWithClutch)
        );
    }, [JSON.stringify(mechanicalPreferences), realizeWithClutch]);
}
